import React from "react";
import { Container } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import "./Innerpage.css";
import Slider from "react-slick";
import portfolioData from "../../../../portfolio";
import laptop from "../../../../Asset/portfolio/laptop-screen.png";
import iphone from "../../../../Asset/portfolio/iPhone-Frame.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import challenge from "../../../../Asset/portfolio/challenge.svg";
import deliverable from "../../../../Asset/portfolio/deliverable.svg";
import conclusion from "../../../../Asset/portfolio/conclusion.svg";
import Shallwetalk from "../../../WhoweAre/CompanyOverview/Shallwetalk/Shallwetalk";
import Othercreation from "./Othercreation";
import mail from "../../../../Asset/portfolio/mail.png";

const InnerPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigateHome = () => {
    navigate("/");
  };

  const handleNavigateBlog = () => {
    navigate("/portfolio");
  };

  const { title } = location.state || {};

  const portfolioItem = portfolioData.find((item) => item.title === title);

  const formatDescription = (description) => {
    if (!description) return "No matching portfolio description found.";
    const words = description.split(" ");
    const half = Math.floor(words.length / 2);
    const firstHalf = words.slice(0, half).join(" ");
    const secondHalf = words.slice(half).join(" ");
    return (
      <>
        {firstHalf}{" "}
        <strong style={{ color: "var(--primary-color)" }}>{secondHalf}</strong>
      </>
    );
  };

  const settings = {
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0",
    focusOnSelect: true,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    arrows: false,
    initialSlide: 0,
  };

  return (
    <>
      <section className="inner-page-blog-section">
        <Container>
          <ul className="top-nav-blog">
            <li>
              <p onClick={handleNavigateHome}>Home</p>
              <span>/</span>
            </li>
            <li>
              <p onClick={handleNavigateBlog}>Portfolio</p>
              <span>/</span>
            </li>
            <li className="active" style={{ color: "var(--primary-color)" }}>
              {title ? <p>&nbsp; {title}</p> : <p>No Portfolio Selected</p>}
            </li>
          </ul>
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-md-6 main-text-innerPortfolio">
              <h2>
                {portfolioItem
                  ? formatDescription(portfolioItem.description)
                  : "No matching portfolio description found."}
              </h2>
            </div>
            <div className="col-12 col-md-6 side-img-innerPortfolio">
              <a
                href={portfolioItem?.link || "#"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="w-100"
                  src={portfolioItem?.rightImg || ""}
                  alt="inner-portfolio-right-img"
                />
              </a>
            </div>
          </div>
        </Container>
      </section>

      {/* ----------------------------------- project summary section ----------------------------------- */}

      <section className="project-summary-section">
        <Container>
          <div className="top-text-why-choose">
            <h2>
              PROJECT <span>SUMMARY</span>
            </h2>
          </div>
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-md-6">
              {!Array.isArray(portfolioItem?.slideImg) ? (
                <div className="paid-video-laptop">
                  <img
                    src={laptop}
                    className="w-100 laptop-screen"
                    alt="laptop"
                  />
                  <div className="video-card">
                    <img
                      src={portfolioItem?.slideImg || ""}
                      className="w-100 image-slide"
                      alt="slide"
                    />
                  </div>
                </div>
              ) : (
                <div className="inner-portfolio-slider">
                  <div className="mobile-screen">
                    <img src={iphone} className="mobile-frame" alt="iphone" />
                    <div className="mobile-frame-card">
                      <Slider {...settings}>
                        {portfolioItem.slideImg.map((img, index) => (
                          <div className="slide" key={index}>
                            <img src={img} alt={`Slide ${index + 1}`} />
                          </div>
                        ))}
                      </Slider>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="col-12 col-md-6">
              {portfolioItem?.paragraphs?.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
              <div className="indus-country d-flex">
                <div className="indus w-50">
                  <h6>Industry</h6>
                  {portfolioItem?.industry?.map((category, index) => (
                    <div
                      className="indus-img d-flex align-items-center mb-2"
                      key={index}
                    >
                      <img src={category?.industryImg} alt={category.name} />
                      <p className="mb-0 ms-3">{category?.name}</p>
                    </div>
                  ))}
                </div>
                <div className="indus w-50">
                  <h6>Country</h6>
                  {portfolioItem?.country.map((category, index) => (
                    <div
                      className="indus-img d-flex align-items-center"
                      key={index}
                    >
                      <img src={category?.countryImg} alt={category?.name} />
                      <p className="mb-0 ms-3">{category?.name}</p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="inner-portfoloio-services my-2">
                <h6>Services</h6>
                <div className="d-flex flex-wrap align-items-center">
                  {portfolioItem?.services.map((category, index) => (
                    <div
                      className="indus-img d-flex align-items-center me-2 mb-2 w-100"
                      key={index}
                    >
                      <img src={category?.servicesImg} alt={category?.name} />
                      <p className="mb-0 ms-3">{category?.name}</p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="inner-portfoloio-technologies my-2">
                <h6>Technologies</h6>
                <div className="d-flex flex-wrap align-items-center">
                  {portfolioItem?.technologies.map((category, index) => (
                    <OverlayTrigger
                      key={index}
                      placement="bottom" // You can adjust the placement to "bottom", "left", or "right"
                      overlay={
                        <Tooltip
                          id={`tooltip-${index}`}
                          style={{ color: "white" }}
                        >
                          {category.name}
                        </Tooltip>
                      }
                    >
                      <div className="inner-technologies-img">
                        <img
                          src={category?.technologieImg}
                          alt={category?.name}
                        />
                      </div>
                    </OverlayTrigger>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* ---------------------------------- challenges section -------------------------------------- */}

      {portfolioItem?.challenges && (
        <section className="inner-challenges-section">
          <Container>
            <div className="row justify-content-center align-items-start inner-spacing-row">
              <div className="col-12 col-md-5">
                <div className="d-flex justify-content-start align-items-center">
                  <img src={challenge} alt="challenges" />
                  <h1>Challenges</h1>
                </div>
              </div>
              <div className="col-12 col-md-7">
                <div className="inner-portfoloio-challenges-text">
                  {portfolioItem?.challenges.intro && (
                    <p>{portfolioItem?.challenges.intro}</p>
                  )}
                  {portfolioItem?.challenges.info && (
                    <>
                      {portfolioItem?.challenges.info.map((info) => (
                        <p
                          style={{
                            fontSize: "16px",
                            color: "#4c5256",
                            lineHeight: "26px",
                          }}
                        >
                          {info}
                        </p>
                      ))}
                    </>
                  )}
                  {portfolioItem?.challenges.points && (
                    <ul>
                      {portfolioItem?.challenges.points.map((point, index) => (
                        <li key={index}>
                          {point.split(/('.*?')/).map((part, partIndex) => {
                            // Check if the part starts and ends with single quotes
                            if (part.startsWith("'") && part.endsWith("'")) {
                              return (
                                <span
                                  key={partIndex}
                                  style={{
                                    color: "var(--primary-color)",
                                    fontWeight: "700",
                                  }}
                                >
                                  {part.slice(1, -1)}
                                </span>
                              );
                            }
                            return part; // Return the rest of the text as is
                          })}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </Container>
        </section>
      )}

      {/* --------------------------------------- deliverables ------------------------------------------- */}

      {portfolioItem?.deliverables && (
        <section className="inner-deliverables-section">
          <Container>
            <div className="row justify-content-center align-items-start inner-spacing-row">
              <div className="col-12 col-md-5">
                <div className="d-flex justify-content-start align-items-center">
                  <img src={deliverable} alt="deliverable" />
                  <h1>Deliverables</h1>
                </div>
              </div>
              <div className="col-12 col-md-7">
                <div className="inner-portfoloio-challenges-text">
                  {portfolioItem.deliverables.intro && (
                    <p>{portfolioItem.deliverables.intro}</p>
                  )}
                  {portfolioItem.deliverables.info && (
                    <>
                      {portfolioItem.deliverables.info.map((info) => (
                        <p
                          style={{
                            fontSize: "16px",
                            color: "#4c5256",
                            lineHeight: "26px",
                          }}
                        >
                          {info}
                        </p>
                      ))}
                    </>
                  )}
                  {portfolioItem.deliverables.points && (
                    <ul>
                      <>
                        {portfolioItem.deliverables.points.map(
                          (point, index) => (
                            <li key={index}>
                              {point.split(/('.*?')/).map((part, partIndex) => {
                                // Check if the part starts and ends with single quotes
                                if (
                                  part.startsWith("'") &&
                                  part.endsWith("'")
                                ) {
                                  return (
                                    <span
                                      key={partIndex}
                                      style={{
                                        color: "var(--primary-color)",
                                        fontWeight: "700",
                                      }}
                                    >
                                      {part.slice(1, -1)}
                                    </span>
                                  );
                                }
                                return part; // Return the rest of the text as is
                              })}
                            </li>
                          )
                        )}
                      </>
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </Container>
        </section>
      )}

      {/* -------------------------------------- conclusion -------------------------------------------- */}

      {portfolioItem?.conclusions && (
        <section className="inner-conclusion-section">
          <Container>
            <div className="row justify-content-center align-items-start inner-spacing-row">
              <div className="col-12 col-md-5">
                <div className="d-flex justify-content-start align-items-center">
                  <img src={conclusion} alt="conclusion" />
                  <h1>Conclusion</h1>
                </div>
              </div>
              <div className="col-12 col-md-7">
                <div className="inner-portfoloio-challenges-text">
                  {portfolioItem.conclusions.intro && (
                    <p>{portfolioItem.conclusions.intro}</p>
                  )}
                  {portfolioItem.conclusions.info && (
                    <>
                      {portfolioItem.conclusions.info.map((info) => (
                        <p
                          style={{
                            fontSize: "16px",
                            color: "#4c5256",
                            lineHeight: "26px",
                          }}
                        >
                          {info}
                        </p>
                      ))}
                    </>
                  )}
                  {portfolioItem.conclusions.points && (
                    <ul>
                      {portfolioItem.conclusions.points.map((point, index) => (
                        <li key={index}>
                          {point.split(/('.*?')/).map((part, partIndex) => {
                            // Check if the part starts and ends with single quotes
                            if (part.startsWith("'") && part.endsWith("'")) {
                              return (
                                <span
                                  key={partIndex}
                                  style={{
                                    color: "var(--primary-color)",
                                    fontWeight: "700",
                                  }}
                                >
                                  {part.slice(1, -1)}
                                </span>
                              );
                            }
                            return part; // Return the rest of the text as is
                          })}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </Container>
        </section>
      )}

      {/* --------------------------------Client Testimonial Section---------------------------- */}

      {portfolioItem?.clientInfo && (
        <section className="client-testimonial-section favorite-section">
          <Container>
            <div className="top-text-favorite">
              <h2>
                CLIENT <span>TESTIMONIAL</span>
              </h2>
            </div>
            <div className="client-details-section">
              <div className="client-box">
                <div className="d-flex  justify-content-between">
                  <div className="d-flex flex-wrap client-info-block">
                    <img
                      src={portfolioItem.clientInfo.clientImg}
                      alt={portfolioItem.clientInfo.clientName}
                    />
                    <div className="client-details">
                      <h3>{portfolioItem.clientInfo.clientName}</h3>
                      <span>{portfolioItem.clientInfo.clientPosition}</span>
                    </div>
                  </div>
                  <div className="mail-box">
                    <img src={mail} alt="mail" className="mx-4" />
                  </div>
                </div>
                <p className="m-0">“{portfolioItem.clientInfo.review}”</p>
              </div>
            </div>
          </Container>
        </section>
      )}

      <Shallwetalk />
      <Othercreation portfolioItem={portfolioItem} />
    </>
  );
};

export default InnerPage;
